import React, { useEffect, useReducer, useContext, createContext } from "react";

import GlobalReducer from "../Reducer/GlobalReducer"; // adjust the path as needed
import axios from "axios";

const initialState = {
  globalDate: null,
  globalCurrentFY: null,
  activeReportPage: "DRM`s Diary New",
  userData: null,
  tokenLoginLoading: false,
  activeInsertionPage: "Dashboard",
};

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX; // Fallback URL
  const [state, dispatch] = useReducer(GlobalReducer, initialState);

  const getOnePreviousDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1); // Subtract 1 day

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const currentDate = getOnePreviousDate();

  const setDateForGlobal = (date) => {
    dispatch({ type: "SET_GLOBAL_DATE", payload: date });
  };

  const setUserData = (date) => {
    dispatch({ type: "SET_USER_DATA", payload: date });
  };

  const setCurrentFy = (fy) => {
    dispatch({ type: "SET_GLOBAL_CURRENT_FY", payload: fy });
  };

  const setActiveReportPage = (page) => {
    dispatch({ type: "SET_GLOBAL_ACTIVE_REPORT_PAGE", payload: page });
  };
  const setActiveInsertionPage = (page) => {
    dispatch({ type: "SET_GLOBAL_ACTIVE_INSERTION_PAGE", payload: page });
  };
  const tokenCheck = async () => {
    if (!localStorage.token) {
      dispatch({
        type: "SET_TOKEN_LOGIN_START",
        payload: { tokenLoginLoading: true },
      });
      return;
    }

    try {
      const response = await axios.get(`${urlPrefix}protected`, {
        headers: {
          Authorization: `Bearer ${localStorage.token}`,
        },
      });
      if (response.statusText === "OK") {
        dispatch({
          type: "SET_TOKEN_LOGIN_DATA",
          payload: {
            tokenLoginLoading: false,
            userData: { ...response.data.user, loginThroughToken: true },
          },
        });
      }
    } catch (err) {
      console.error("Login error:", err);
      dispatch({
        type: "SET_TOKEN_LOGIN_ERROR",
        payload: { tokenLoginLoading: false, error: err },
      });
    } finally {
      // setLoading(false);
      dispatch({
        type: "SET_TOKEN_LOGIN_FINISH",
        payload: { tokenLoginLoading: false },
      });
    }
  };

  useEffect(() => {
    tokenCheck();
  }, []);

  useEffect(() => {
    if (currentDate) {
      const year = parseInt(currentDate.slice(0, 4), 10);
      const month = parseInt(currentDate.slice(5, 7), 10);

      // Financial year usually starts in April
      const fyStartYear = month >= 4 ? year : year - 1;
      const fy = `${fyStartYear}-${fyStartYear + 1}`;

      setDateForGlobal(currentDate);
      setCurrentFy(fy);
    }
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        ...state,
        setDateForGlobal,
        setCurrentFy,
        setActiveReportPage,
        setUserData,
        setActiveInsertionPage,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(GlobalContext);
};

export { GlobalContext };
